<template>
  <div class="my-audit-orders-container">
    <ds-page-header :title="$t('myAuditOrders.page.title')" :subtitle="$t('myAuditOrders.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-back" @click="goBack">{{ $t('myAuditOrders.back') }}</el-button>
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="_queryAuditOrdersMethod">
          {{ $t('myAuditOrders.refresh') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel">
      <ds-toolbar :total="total" :density="density" :show-column-setting="false" :show-refresh="true"
        @update:density="density = $event" @refresh="_queryAuditOrdersMethod">
        <template #left><span class="ds-panel__title">{{ $t('myAuditOrders.todoList') }}</span></template>
      </ds-toolbar>
      <ds-data-table :data="auditOrdersInfo.auditOrders" :loading="loading" :error="hasError"
        :error-message="errorMessage" :density="density" border stripe
        :empty-description="$t('myAuditOrders.page.empty')" @retry="_queryAuditOrdersMethod">
        <el-table-column prop="applyOrderId" :label="$t('myAuditOrders.orderNumber')" align="center" min-width="140">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.applyOrderId || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="resOrderTypeName" :label="$t('myAuditOrders.orderType')" align="center" min-width="110">
          <template slot-scope="scope"><ds-status-tag size="sm" type="info" :label="scope.row.resOrderTypeName || '-'" /></template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('myAuditOrders.orderStatus')" align="center" width="110">
          <template slot-scope="scope"><ds-status-tag size="sm" type="muted" :label="scope.row.stateName || '-'" /></template>
        </el-table-column>
        <el-table-column prop="userName" :label="$t('myAuditOrders.applicant')" align="center" min-width="100" />
        <el-table-column prop="createTime" :label="$t('myAuditOrders.createTime')" align="center" width="170" sortable>
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.createTime || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('myAuditOrders.operation')" align="center" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openDetailPurchaseApplyModel(scope.row)">{{ $t('myAuditOrders.view') }}</el-button>
            <el-button size="mini" v-if="scope.row.createUserId == auditOrdersInfo.currentUserId"
              @click="_openEditPurchaseModel(scope.row)">{{ $t('myAuditOrders.edit') }}</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.curTaskName == '仓库管理员'"
              @click="_procureEnterOrder(scope.row)">{{ $t('myAuditOrders.procurement') }}</el-button>
            <el-button size="mini" type="success" v-else @click="_openAuditOrderModel(scope.row)">{{ $t('myAuditOrders.audit') }}</el-button>
          </template>
        </el-table-column>
      </ds-data-table>
      <ds-pagination-bar :page="currentPage" :size="pageSize" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { listAuditOrders, listWorkflowStepStaffs } from '@/api/resource/myAuditOrdersApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'MyAuditOrdersList',
  components: { DsPageHeader, DsToolbar, DsDataTable, DsPaginationBar, DsStatusTag },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      auditOrdersInfo: {
        auditOrders: [],
        total: 0,
        records: 1,
        moreCondition: false,
        userName: '',
        currentUserId: '',
        conditions: { AuditOrdersId: '', userName: '', auditLink: '', page: 1, row: 10 },
        orderInfo: '',
        procure: false,
        audit: '1'
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this._initMethod()
  },
  mounted() {
    this._initEvent()
  },
  methods: {
    _initMethod() {
      this._listAuditOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      this._loadStepStaff()
    },
    _initEvent() {
    },
    async _listAuditOrders(_page, _rows) {
      this.auditOrdersInfo.audit = '1'
      this.auditOrdersInfo.conditions.page = _page
      this.auditOrdersInfo.conditions.row = _rows
      try {
        this.loading = true
        this.hasError = false
        const res = await listAuditOrders(this.auditOrdersInfo.conditions)
        this.auditOrdersInfo.total = res.total
        this.auditOrdersInfo.records = res.records
        this.auditOrdersInfo.auditOrders = res.data
        this.total = res.total
        this.currentPage = _page
      } catch (error) {
        console.error('请求失败:', error)
        this.hasError = true
        this.errorMessage = this.$t('common.loadError')
      } finally {
        this.loading = false
      }
    },
    _openAuditOrderModel(_purchaseApply) {
      this.$router.push({
        path: '/views/resource/purchaseApplyDetail',
        query: {
          applyOrderId: _purchaseApply.applyOrderId,
          resOrderType: _purchaseApply.resOrderType,
          action: 'audit',
          taskId: _purchaseApply.taskId,
          flowId: _purchaseApply.flowId
        }
      })
    },
    _queryAuditOrdersMethod() {
      this._listAuditOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _openDetailPurchaseApplyModel(_purchaseApply) {
      this.$router.push({
        path: '/views/resource/purchaseApplyDetail',
        query: {
          applyOrderId: _purchaseApply.applyOrderId,
          resOrderType: _purchaseApply.resOrderType
        }
      })
    },
    async _loadStepStaff() {
      try {
        const res = await listWorkflowStepStaffs({
          page: 1,
          row: 1,
          staffId: this.auditOrdersInfo.currentUserId,
          staffRole: '2002',
          requestType: 'purchaseHandle'
        })
        if (res.data.length > 0) {
          this.auditOrdersInfo.procure = true
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _procureEnterOrder(_purchaseApply) {
      this.$router.push({
        path: '/views/resource/resourceEnterManage',
        query: {
          applyOrderId: _purchaseApply.applyOrderId,
          resOrderType: _purchaseApply.resOrderType,
          taskId: _purchaseApply.taskId
        }
      })
    },
    _openEditPurchaseModel(_purchaseApply) {
      this.$router.push({
        path: '/pages/resource/editPurchaseApply',
        query: {
          applyOrderId: _purchaseApply.applyOrderId,
          resOrderType: _purchaseApply.resOrderType
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this._listAuditOrders(this.currentPage, val)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listAuditOrders(val, this.pageSize)
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.my-audit-orders-container { padding: var(--ds-spacing-lg); background-color: var(--ds-gray-100); min-height: calc(100vh - 60px); }
.ds-panel { background: #fff; border: 1px solid var(--ds-gray-300); border-radius: var(--ds-radius-md); box-shadow: var(--ds-shadow-sm); overflow: hidden; margin-bottom: var(--ds-spacing-lg);
  &__title { font-size: var(--ds-font-size-lg); font-weight: 600; color: var(--ds-gray-800); } }
</style>
